import { render, staticRenderFns } from "./AppItem.vue?vue&type=template&id=214ed83d&scoped=true"
import script from "./AppItem.vue?vue&type=script&lang=js"
export * from "./AppItem.vue?vue&type=script&lang=js"
import style0 from "./AppItem.vue?vue&type=style&index=0&id=214ed83d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ed83d",
  null
  
)

export default component.exports